import { BaseModel } from '@/api/base-model'
import { PrintableDocumentAPI } from '@/api/backend-client'
import { Company } from '@/api/model/company'

export class PrintableDocument extends BaseModel<PrintableDocument> {
    protected collectionName = PrintableDocumentAPI.collectionName

    constructor(
        public company: Company|null,
        public id: string,
        public name: string,
        public description: string,
        public url: string,
        public productId: string,
        public active: boolean,
        public createdAt: Date,
        public updatedAt: Date,
    ) { super(id) }

    static fromData(data: any): PrintableDocument {
        if (data === null || typeof data === 'string' || data instanceof PrintableDocument) {
            return data
        }

        return new PrintableDocument(
            data.company ? Company.fromData(data.company) : null,
            data.id,
            data.name,
            data.description,
            data.url,
            data.productId,
            data.active,
            data.createdAt,
            data.updatedAt,
        )
    }
}
